import * as stylex from '@stylexjs/stylex';

const twinkle = stylex.keyframes({
    '0%, 100%': {
        opacity: 0.3, transform: 'scale(1)'
    }

    ,
    '50%': {
        opacity: 1, transform: 'scale(1.5)'
    }

    ,
});

const gradientShift = stylex.keyframes({
    '0%, 100%': {
        backgroundPosition: '0% 50%'
    }

    ,
    '50%': {
        backgroundPosition: '100% 50%'
    }

    ,
});

const fadeIn = stylex.keyframes({
    from: {
        opacity: 0
    }

    ,
    to: {
        opacity: 1
    }

    ,
});

const shimmer = stylex.keyframes({
    '0%': {
        left: '-100%'
    }

    ,
    '100%': {
        left: '100%'
    }

    ,
});

const MOBILE = '@media (max-width: 768px)';
const SMALL_MOBILE = '@media (max-width: 480px)';

export const styles = stylex.create({
    quickStartPage: {
        maxWidth: '100%',
        marginInline: 'auto',
        padding: 0,
        minHeight: '100vh',
        position: 'relative',
        overflow: 'hidden',
    }

    ,
    animatedBackground: {
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none',
    }

    ,
    star: {
        position: 'absolute',
        width: '2px',
        height: '2px',
        backgroundColor: 'white',
        borderRadius: '50%',
        animationName: twinkle,
        animationDuration: '3s',
        animationIterationCount: 'infinite',
    }

    ,
    star1: {
        top: '20%', left: '10%', animationDelay: '0s'
    }

    ,
    star2: {
        top: '40%', left: '80%', animationDelay: '0.5s'
    }

    ,
    star3: {
        top: '60%', left: '30%', animationDelay: '1s'
    }

    ,
    star4: {
        top: '80%', left: '70%', animationDelay: '1.5s'
    }

    ,
    star5: {
        top: '30%', left: '50%', animationDelay: '2s'
    }

    ,

    backLink: {

        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        color: {
            default: 'var(--text-secondary)',
            ':hover': 'var(--primary)',
        }

        ,
        textDecoration: 'none',
        fontSize: 'var(--font-size-sm)',
        marginBottom: 'var(--spacing-xl)',
        transitionProperty: 'color',
        transitionDuration: 'var(--transition-fast)',
        position: 'relative',
        zIndex: 10,
        padding: 'var(--spacing-md)',
    }

    ,
    pageHeader: {

        backgroundImage: `linear-gradient(135deg, var(--bg-card) 0%, rgba(59, 130, 246, 0.02) 15%, rgba(16, 185, 129, 0.02) 35%, rgba(255, 107, 107, 0.02) 55%, rgba(139, 92, 246, 0.02) 75%, var(--bg-card) 100%)`,
        borderRadius: 'var(--radius-xl)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'var(--border)',
        padding: 'var(--spacing-2xl)',
        marginBottom: 'var(--spacing-3xl)',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        backdropFilter: 'blur(4px)',
        '::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: `radial-gradient(circle at 15% 40%, rgba(59, 130, 246, 0.03) 0%, transparent 50%), radial-gradient(circle at 85% 60%, rgba(16, 185, 129, 0.03) 0%, transparent 50%), radial-gradient(circle at 40% 20%, rgba(255, 107, 107, 0.02) 0%, transparent 50%), radial-gradient(circle at 60% 80%, rgba(139, 92, 246, 0.02) 0%, transparent 50%)`,
            opacity: 1,
        }

        ,
        '::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: `radial-gradient(circle at 70% 30%, rgba(255, 193, 7, 0.01) 0%, transparent 40%), radial-gradient(circle at 30% 70%, rgba(156, 39, 176, 0.01) 0%, transparent 40%)`,
            opacity: 0.8,
        }

        ,
    }

    ,
    pageTitle: {
        fontSize: {
            default: '3.5rem',
            [MOBILE]: '2.5rem',
            [SMALL_MOBILE]: '2rem',
        }

        ,
        fontWeight: 700,
        color: 'var(--text-primary)',
        margin: 0,
        letterSpacing: '-0.02em',
    }

    ,
    gradientText: {
        backgroundImage: 'linear-gradient(135deg, #256d9d, #ec4899, #f99316)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        backgroundClip: 'text',
        animationName: gradientShift,
        animationDuration: '2s',
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite',
        backgroundSize: '200% 200%',
    }

    ,
    quickStartSection: {
        marginBottom: 'var(--spacing-3xl)',
        position: 'relative',
        zIndex: 1,
    }

    ,
    stepsContainer: {

        display: 'flex',
        flexDirection: 'column',
        gap: {
            default: '120px',
            [MOBILE]: '90px',
            [SMALL_MOBILE]: '70px',
        }

        ,
        maxWidth: '900px',
        marginInline: 'auto',
        paddingInline: 'var(--spacing-lg)',
    }

    ,
    stepRow: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        position: 'relative',
    }

    ,
    stepNumber: {
        width: {
            default: '48px', [MOBILE]: '60px'
        }

        ,
        height: {
            default: '48px', [MOBILE]: '60px'
        }

        ,
        backgroundColor: 'var(--primary)',
        color: 'var(--text-on-accent)',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontWeight: 700,
        flexShrink: 0,
        position: 'relative',
        '::after': {
            content: '""',
            position: 'absolute',
            bottom: '-20px',
            left: '50%',
            transform: 'translateX(-50%)',
            width: '2px',
            height: '20px',
            backgroundColor: 'var(--border)',
        }

        ,
    }

    ,
    numberText: {
        fontSize: {
            default: '2rem', [MOBILE]: '1.5rem'
        }

        ,
        fontWeight: 700,
        color: 'var(--text-on-accent)',
    }

    ,
    stepHeader: {

        marginBottom: '24px',
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--spacing-lg)',
        justifyContent: 'center',
        flexDirection: {
            [MOBILE]: 'column'
        }

        ,
    }

    ,
    stepTitle: {
        fontSize: {
            default: '2rem', [MOBILE]: '1.5rem', [SMALL_MOBILE]: '1.25rem'
        }

        ,
        fontWeight: 700,
        color: 'var(--text-primary)',
        margin: 0,
    }

    ,
    stepDescription: {

        color: 'var(--text-secondary)',
        lineHeight: 1.8,
        marginBlock: {
            default: '0 50px',
            [MOBILE]: '0 35px',
            [SMALL_MOBILE]: '0 30px',
        }

        ,
        maxWidth: '700px',
        fontSize: 'var(--font-size-lg)',
    }

    ,
    stepFeatures: {

        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 'var(--spacing-md)',
        paddingBottom: '50px',
        marginBottom: {
            default: '50px', [MOBILE]: '30px', [SMALL_MOBILE]: '25px'
        }

        ,
    }

    ,
    featureItem: {
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        paddingBlock: 'var(--spacing-sm)',
        paddingInline: 'var(--spacing-md)',
        backgroundColor: 'rgba(168, 85, 247, 0.1)',
        borderRadius: '20px',
        color: 'var(--text-secondary)',
        fontSize: 'var(--font-size-sm)',
    }

    ,
    featureCheck: {
        width: '20px',
        height: '20px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--primary)',
    }

    ,
    stepImage: {
        width: '100%',
        maxWidth: '800px',
        marginBlock: '0 40px',
        marginInline: 'auto',
        position: 'relative',
        objectFit: 'contain',
    }

    ,
    stepImageGallery: {

        width: '100%',
        maxWidth: '800px',
        marginBlock: {
            default: '0 80px', [MOBILE]: '0 45px', [SMALL_MOBILE]: '0 40px'
        }

        ,
        marginInline: 'auto',
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        paddingBlock: '40px 60px',
        paddingInline: {
            default: '20px', [MOBILE]: '15px'
        }

        ,
        minHeight: {
            default: '500px', [MOBILE]: '350px', [SMALL_MOBILE]: '300px'
        }

        ,
    }

    ,
    stepImageContainer: {
        position: 'relative',
        width: '100%',
        transitionProperty: 'opacity, transform, filter',
        transitionDuration: '0.3s',
    }

    ,
    activeImage: {
        opacity: 1, transform: 'none', filter: 'none'
    }

    ,
    inactiveImage: {
        opacity: 0, position: 'absolute'
    }

    ,
    imageWrapper: {

        position: 'relative',
        borderRadius: '16px',
        overflow: 'hidden',
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: {
            default: 'rgba(168, 85, 247, 0.5)', ':hover': 'rgba(168, 85, 247, 0.8)'
        }

        ,
        boxShadow: {
            default: '0 20px 60px rgba(0, 0, 0, 0.5), 0 0 40px rgba(168, 85, 247, 0.3)',
            ':hover': '0 30px 80px rgba(0, 0, 0, 0.6), 0 0 60px rgba(168, 85, 247, 0.5)',
        }

        ,
        transitionProperty: 'all',
        transitionDuration: '0.3s',
        backgroundColor: 'rgba(26, 26, 62, 0.3)',
        display: 'block',
        lineHeight: 0,
        transform: {
            default: 'none', ':hover': 'translateY(-4px)'
        }

        ,
    }

    ,
    imageMedia: {
        width: '100%',
        height: '100%',
        display: 'block',
        objectFit: 'cover',
    }

    ,
    imageControls: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        gap: '12px',
        opacity: 0,
        transitionProperty: 'opacity',
        transitionDuration: '0.3s',
        zIndex: 10,
    }

    ,
    controlIconVisible: {
        opacity: 1
    }

    ,
    gifControl: {

        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '50%',
        padding: '12px',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '0.3s',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ':hover': {
            backgroundColor: 'rgba(169, 85, 247, 0.112)',
            transform: 'scale(1.1)',
        }

        ,
    }

    ,
    playIcon: {
        color: 'rgba(255, 255, 255, 0.745)'
    },
    pauseIcon: {
        color: 'rgba(255, 255, 255, 0.745)'
    },
    fullscreenIcon: {
        color: 'rgba(255, 255, 255, 0.745)'
    }

    ,
    fullscreenControl: {

        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        borderRadius: '50%',
        padding: '12px',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '0.3s',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ':hover': {
            backgroundColor: 'rgba(169, 85, 247, 0.095)',
            transform: 'scale(1.1)',
        }

        ,
    }

    ,
    fullscreenModal: {
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.95)',
        zIndex: 9999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'clamp(16px, 4vw, 40px)',
        backdropFilter: 'blur(10px)',
        animationName: fadeIn,
        animationDuration: '0.3s',
    }

    ,
    closeFullscreen: {

        position: 'absolute',
        top: '20px',
        right: '20px',
        backgroundColor: {
            default: 'rgba(255, 255, 255, 0.1)', ':hover': 'rgba(255, 255, 255, 0.2)'
        }

        ,
        borderWidth: 0,
        borderRadius: '50%',
        padding: '12px',
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '0.3s',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 10001,
        transform: {
            ':hover': 'scale(1.1)'
        }

        ,
    }

    ,
    fullscreenContent: {
        width: {
            default: 'min(1200px, 95vw)', [MOBILE]: '100%'
        }

        ,
        maxHeight: '90vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }

    ,
    fullscreenMediaWrapper: {

        position: 'relative',
        width: '100%',
        height: '100%',
        maxHeight: {
            default: '90vh', [MOBILE]: '80vh', [SMALL_MOBILE]: '75vh'
        }

        ,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }

    ,
    fullscreenImage: {
        width: '100%',
        height: '100%',
        maxHeight: '90vh',
        objectFit: 'contain',
        borderRadius: '16px',
        boxShadow: '0 20px 80px rgba(0, 0, 0, 0.5)',
        backgroundColor: '#000',
    }

    ,
    fullscreenControls: {

        position: 'absolute',
        bottom: {
            default: '24px', [MOBILE]: '12px'
        }

        ,
        left: '50%',
        transform: 'translateX(-50%)',
        width: {
            default: 'calc(100% - 48px)', [MOBILE]: 'calc(100% - 24px)'
        }

        ,
        display: 'flex',
        justifyContent: 'center',
        pointerEvents: 'none',
    }

    ,
    fullscreenControlButton: {

        display: 'inline-flex',
        alignItems: 'center',
        gap: '8px',
        paddingBlock: '12px',
        paddingInline: '28px',
        borderRadius: '999px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: {
            default: 'rgba(255, 255, 255, 0.2)', ':hover': 'rgba(255, 255, 255, 0.4)'
        }

        ,
        backgroundColor: {
            default: 'rgba(0, 0, 0, 0.65)', ':hover': 'rgba(168, 85, 247, 0.4)'
        }

        ,
        backdropFilter: 'blur(8px)',
        color: 'white',
        fontWeight: 600,
        cursor: 'pointer',
        transitionProperty: 'all',
        transitionDuration: '0.3s',
        fontSize: '14px',
        pointerEvents: 'auto',
        boxShadow: {
            ':hover': '0 8px 24px rgba(168, 85, 247, 0.35)'
        }

        ,
        width: {
            [MOBILE]: '100%'
        }

        ,
        justifyContent: {
            [MOBILE]: 'center'
        }

        ,
    }

    ,
    stepAction: {

        display: 'inline-flex',
        alignItems: 'center',
        gap: 'var(--spacing-sm)',
        paddingBlock: '30px',
        paddingInline: '32px',
        textDecoration: 'none',
        borderRadius: 'var(--radius-md)',
        fontWeight: 600,
        fontSize: 'var(--font-size-md)',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-fast)',
        transform: {
            ':hover': 'translateX(4px)'
        }

        ,
        backgroundColor: {
            ':hover': 'var(--primary-bg-subtle)'
        }

        ,
    }

    ,
    actionIcon: {
        transitionProperty: 'transform',
        transitionDuration: 'var(--transition-fast)',
    }

    ,
    additionalFeaturesSection: {
        marginBottom: 'var(--spacing-3xl)',
    }

    ,
    featuresGrid: {

        display: 'grid',
        gridTemplateColumns: {
            default: 'repeat(auto-fit, minmax(300px, 1fr))', [MOBILE]: '1fr'
        }

        ,
        gap: 'var(--spacing-lg)',
    }

    ,
    featureCard: {

        display: 'flex',
        alignItems: 'center',
        gap: 'var(--spacing-md)',
        padding: 'var(--spacing-lg)',
        backgroundColor: 'var(--bg-card)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: {
            default: 'var(--border)', ':hover': 'var(--border-hover)'
        }

        ,
        borderRadius: 'var(--radius-md)',
        textDecoration: 'none',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-fast)',
        position: 'relative',
        overflow: 'hidden',
        transform: {
            ':hover': 'translateY(-2px)'
        }

        ,
        boxShadow: {
            ':hover': 'var(--shadow-md)'
        }

        ,
        '::before': {

            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: `linear-gradient(45deg, rgba(var(--primary-rgb, 60, 60, 60), 0.05), rgba(var(--accent-rgb, 60, 60, 60), 0.05))`,
            opacity: {
                default: 0, ':hover': 1
            }

            ,
            transitionProperty: 'opacity',
            transitionDuration: 'var(--transition-fast)',
        }

        ,
    }

    ,
    featureIcon: {
        width: '40px',
        height: '40px',
        backgroundColor: 'var(--primary-bg-subtle)',
        borderRadius: 'var(--radius-md)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'var(--primary)',
        flexShrink: 0,
    }

    ,
    featureContent: {
        flex: 1
    }

    ,
    featureTitle: {
        fontSize: 'var(--font-size-md)',
        fontWeight: 600,
        color: 'var(--text-primary)',
        marginBlock: '0 var(--spacing-xs)',
    }

    ,
    featureDescription: {
        color: 'var(--text-secondary)',
        fontSize: 'var(--font-size-sm)',
        margin: 0,
        lineHeight: 1.5,
    }

    ,
    featureArrow: {
        color: 'var(--text-tertiary)',
        transitionProperty: 'all',
        transitionDuration: 'var(--transition-fast)',
    }

    ,
    ctaSection: {

        backgroundImage: `linear-gradient(135deg, var(--bg-card) 0%, rgba(59, 130, 246, 0.02) 15%, rgba(16, 185, 129, 0.02) 35%, rgba(255, 107, 107, 0.02) 55%, rgba(139, 92, 246, 0.02) 75%, var(--bg-card) 100%)`,
        borderRadius: 'var(--radius-xl)',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'var(--border)',
        padding: 'var(--spacing-2xl)',
        marginBottom: 'var(--spacing-3xl)',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        backdropFilter: 'blur(4px)',
        '::before': {
            content: '""',
            position: 'absolute',
            inset: 0,
            backgroundImage: `radial-gradient(circle at 15% 40%, rgba(59, 130, 246, 0.03) 0%, transparent 50%), radial-gradient(circle at 85% 60%, rgba(16, 185, 129, 0.03) 0%, transparent 50%), radial-gradient(circle at 40% 20%, rgba(255, 107, 107, 0.02) 0%, transparent 50%), radial-gradient(circle at 60% 80%, rgba(139, 92, 246, 0.02) 0%, transparent 50%)`,
            opacity: 1,
        }

        ,
    }

    ,
    ctaContent: {
        position: 'relative', zIndex: 1
    }

    ,
    ctaTitle: {
        fontSize: 'var(--font-size-2xl)',
        fontWeight: 600,
        color: 'var(--text-primary)',
        marginBottom: 'var(--spacing-md)',
    }

    ,
    ctaDescription: {
        fontSize: 'var(--font-size-lg)',
        color: 'var(--text-secondary)',
        marginBottom: 'var(--spacing-xl)',
        maxWidth: '500px',
        marginInline: 'auto',
    }

    ,
    ctaButtons: {
        display: 'flex',
        gap: 'var(--spacing-md)',
        justifyContent: 'center',
        flexWrap: 'wrap',
    }

    ,
    primaryButton: {

        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        backgroundColor: 'var(--accent)',
        color: 'white',
        borderWidth: 0,
        paddingBlock: '0.875rem',
        paddingInline: '1.75rem',
        borderRadius: '8px',
        fontSize: '1rem',
        fontWeight: 600,
        textDecoration: 'none',
        position: 'relative',
        overflow: 'hidden',
        zIndex: 1,
        transitionProperty: 'all',
        transitionDuration: '0.3s',
        cursor: 'pointer',
        transform: {
            ':hover': 'translateY(-3px)'
        }

        ,
        boxShadow: {
            ':hover': '0 10px 20px rgba(0, 0, 0, 0.1)'
        }

        ,
        '::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: '-100%',
            width: '100%',
            height: '100%',
            backgroundImage: 'linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent)',
            zIndex: -1,
            animationName: shimmer,
            animationDuration: '3s',
            animationIterationCount: 'infinite',
        }

        ,
    }

    ,
});